export const GET_EVENTS = 'get-events';
